// eslint-disable-next-line import/prefer-default-export
export const EmployeeAutoNumberingType = Object.freeze({
    Add: 'add',
    Overwrite: 'overwrite',
});
